<template>
    <div>
        <hts-router-drawer
            :title="$t('labels.businessOpportunity')"
            :size="80">
            <div class="mb-3 text-right">
                <hts-form-button
                    v-if="checkPermission(layoutPermissions.partner_business_opportunity_add)"
                    color="main"
                    icon-name="hi-plus-circle-icon"
                    icon-position="right"
                    @click="openAddBusinessOpportunity">
                    {{ $t('labels.add') }}
                </hts-form-button>
            </div>
            <hts-data-table
                ref="dataTables"
                :headers="cooperatorBusinessOpportunity"
                :server="server"
                store-name="cooperatorDataTable"
                store-key="CooperatorBusinessOpportunity"
                :use-archive="useArchive"
                :use-restore="useRestore"
                use-selection />
            <add-business-opportunity
                v-if="checkPermission(layoutPermissions.partner_business_opportunity_add)"
                ref="addBusinessOpportunity"
                :code-cooperator="cooperatorCode"
                @refresh-tables="refreshTables" />
            <hts-modal
                v-if="checkPermission(layoutPermissions.partner_business_opportunity_delete)"
                :show="showPopupDeleteBusinessOpportunity"
                :title="$t('labels.deleteBusinessOpportunity')"
                type="confirm"
                :content="$t('labels.confirmDeleteBusinessOpportunity')"
                @hide="closePopupDeleteCommodity"
                @confirm="handleDeleteCommodity" />
        </hts-router-drawer>
        <router-view @refresh-tables="refreshTables" />
    </div>
</template>

<script setup lang="ts">
import CommodityName from '../-components/tabels/commodity-name.vue'
import AddBusinessOpportunity from './business-opportunity/-components/add.vue'
import { checkPermission } from '@/utils/permission-check'
import layoutPermissions from '~/data/permissions/layout-permissions'

import actions from '~/pages/trucker-[id]/partner/-components/actions.vue'

const cooperatorCode = computed(() => useRoute().params.idpartner)

const { $formatters } = useNuxtApp()
const showPopupDeleteBusinessOpportunity = ref(false)
const openAddBusinessOpportunity = (customer: any) => {
  if (addBusinessOpportunity.value) {
    addBusinessOpportunity.value.open(cooperatorCode.value)
  }
}

const openEditBusinessOpportunity = (businessOpportunity: any) => {
  useRouter().push({
    name: 'trucker-id-partner-idpartner-business-opportunity-idbusinessopportunity-edit',
    params: { idbusinessopportunity: businessOpportunity._id }
  })
}

const openDeleteBusinessOpportunity = (data: any) => {
  businessOpportunityId.value = data?._id
  showPopupDeleteBusinessOpportunity.value = true
}

const makeCopyBusinessOpportunity = async (businessOpportunity: any) => {
  const url = $url.partner.businessOpportunity.makeCopy
  const data: any = await $api(url, { uriParams: { cooperatorId: cooperatorCode.value, ID: businessOpportunity?._id } })
  const resData = data?.data?.value
  if (resData?.success) {
    process.client && $toast().success($t('labels.makeCopySuccess'))
    refreshTables()
  }
}

const replicateBusinessOpportunity = (businessOpportunity: any) => {
  useRouter().push({
    name: 'trucker-id-partner-idpartner-business-opportunity-idbusinessopportunity-replicate',
    params: { idbusinessopportunity: businessOpportunity._id }
  })
}

const cooperatorBusinessOpportunity = [
  {
    field: 'cooperatorDetail.name',
    headerName: $t('labels.nameCompany')
  },
  {
    field: 'code',
    headerName: $t('labels.code')
  },
  {
    field: 'workflowName',
    headerName: $t('labels.workflow'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'positions',
    minWidth: 500,
    headerName: $t('labels.route'),
    sortable: true,
    valueFormatter: (params: any) => {
      if (params.data?.positions && Array.isArray(params.data?.positions)) {
        const pluckData = $lodash.map(params.data?.positions, 'fullNameNode')

        return $lodash.join(pluckData, ' >> ')
      }
    }
  },
  {
    field: 'weightCommodity',
    headerName: $t('labels.weightCommodityByKG'),
    filter: 'agNumberColumnFilter',
    valueGetter: (params: any) => {
      return $formatters.formatCurrency(params.data.weightCommodity)
    }
  },
  {
    field: 'productivity',
    headerName: $t('labels.productivityByMount'),
    filter: 'agNumberColumnFilter',
    valueGetter: (params: any) => {
      return $formatters.formatCurrency(params.data.productivity)
    }
  },
  {
    field: 'commodityDetail',
    headerName: $t('labels.commodityName'),
    cellRenderer: CommodityName,
    autoHeight: true
  },
  {
    field: 'vehicleCategory',
    headerName: $t('labels.vehicleType'),
    valueFormatter: (params: any) => {
      if (params.data?.transportation === 'NON_CONTAINER' && params.data?.vehicleCategoryDetail?.name) {
        return params.data?.vehicleCategoryDetail?.name
      }
      return ''
    }
  },
  {
    field: 'contCategory',
    headerName: $t('labels.containerType'),
    valueFormatter: (params: any) => {
      if (params.data?.transportation === 'CONTAINER' && params.data?.contCategory) {
        if (params.data?.contCategory === 20) {
          return $t('labels.20f')
        }
        if (params.data?.contCategory === 40) {
          return $t('labels.40f')
        }
        if (params.data?.contCategory === 45) {
          return $t('labels.45f')
        }
      }
      return ''
    }
  },
  // {
  //   field: 'typeCommodity',
  //   headerName: $t('labels.row'),
  //   valueFormatter: (params: any) => {
  //     if (params && params.data?.typeCommodity) {
  //       if (params.data?.typeCommodity === 'NORMAL') {
  //         return $t('labels.ordinaryGoods')
  //       } else if (params.data?.typeCommodity === 'OVERWEIGHT') {
  //         return $t('labels.overweightCargo')
  //       }
  //     }
  //     return ''
  //   }
  // },
  // {
  //   field: 'goodType',
  //   headerName: $t('labels.goodsTypes'),
  //   valueFormatter: (params: any) => {
  //     if (params && params.data?.goodType) {
  //       if (params.data?.goodType === 'SOLID') {
  //         return $t('labels.solid')
  //       } else if (params.data?.goodType === 'LIQUID') {
  //         return $t('labels.liquid')
  //       } else if (params.data?.goodType === 'GAS') {
  //         return $t('labels.gas')
  //       }
  //     }
  //     return ''
  //   }
  // },
  {
    field: 'typeReefer',
    headerName: $t('labels.isReefer'),
    valueFormatter: (params: any) => {
      if (params && params.data?.typeReefer) {
        if (params.data?.typeReefer === 'REEFER') {
          return $t('labels.true')
        } else if (params.data?.typeReefer === 'NOTREEFER') {
          return $t('labels.no')
        }
      }
      return ''
    }
  },
  {
    field: 'typeDangerous',
    headerName: $t('labels.isDangerous'),
    valueFormatter: (params: any) => {
      if (params && params.data?.typeDangerous) {
        if (params.data?.typeDangerous === 'DANGEROUS') {
          return $t('labels.dangerous')
        } else if (params.data?.typeDangerous === 'NOTDANGEROUS') {
          return $t('labels.notDangerous')
        }
      }
      return ''
    }
  },
  {
    field: 'typeFragileGoods',
    headerName: $t('labels.isFragile'),
    valueFormatter: (params: any) => {
      if (params && params.data?.typeFragileGoods) {
        if (params.data?.typeFragileGoods === 'FRAGILE') {
          return $t('labels.fragile')
        } else if (params.data?.typeFragileGoods === 'NOTFRAGILE') {
          return $t('labels.notFragile')
        }
      }
      return ''
    }
  },

  {
    field: 'createdAt',
    headerName: $t('labels.createdAt'),
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.createdAt)
    }
  },
  {
    field: 'updatedAt',
    headerName: $t('labels.updatedAt'),
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      return $formatters.datetime(params.data.updatedAt)
    }
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: actions,
    cellRendererParams: {
      storeKey: 'cooperatorDataTable',
      storeName: 'CooperatorBusinessOpportunity',
      items: [
        {
          icon: 'hi-pencil-square-icon',
          label: $t('labels.edit'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.partner_business_opportunity_edit),
          click: openEditBusinessOpportunity
        },
        {
          icon: 'hi-square-2-stack-icon',
          label: $t('labels.makeCopy'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: false,
          click: makeCopyBusinessOpportunity
        },
        {
          icon: 'hi-document-duplicate-icon',
          label: $t('labels.replicate'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.partner_business_opportunity_replicate),
          click: replicateBusinessOpportunity
        },
        {
          icon: 'hi-trash-icon',
          label: $t('labels.delete'),
          class: 'text-error-600 hover:text-error-500',
          permissions: checkPermission(layoutPermissions.partner_business_opportunity_delete),
          click: openDeleteBusinessOpportunity,
          isArchive: true
        }
      ]
    }
  }
]
const visible = ref(false)
const server = {
  method: 'post',
  url: '/partner/business-opportunity/' + cooperatorCode.value + '/list'
}
const businessOpportunityId = ref('')
const dataTables = ref()
const addBusinessOpportunity: any = ref(null)

const props = defineProps({})

const refreshTables = () => {
  if (dataTables.value) {
    dataTables.value.refresh()
  }
}

const closePopupDeleteCommodity = () => {
  showPopupDeleteBusinessOpportunity.value = false
  businessOpportunityId.value = ''
}

const handleDeleteCommodity = () => {
  const api = $url.partner.businessOpportunity.delete
  $api(api, { uriParams: { cooperatorId: cooperatorCode.value, ID: businessOpportunityId.value } })
    .then((data: any) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        process.client && $toast().success($t('labels.deleteBusinessOpportunitySuccess'))
      }
      refreshTables()
      showPopupDeleteBusinessOpportunity.value = false
    })
    .catch(() => {
      showPopupDeleteBusinessOpportunity.value = false
    })
}

const useArchive = { api: $url.partner.businessOpportunity.archive, permissions: checkPermission(layoutPermissions.partner_business_opportunity_archive) }
const useRestore = { api: $url.partner.businessOpportunity.restore, permissions: checkPermission(layoutPermissions.partner_business_opportunity_restore) }
</script>
